import { useRef, useEffect, useMemo } from 'react';
import debounce from 'lodash.debounce';

const defaultOptions = Object.freeze({});

// When calling the function with options, they must be memoized;
// otherwise a new object will be passed on every rerender:
// const options = useMemo(() => ({ leading: true }), []);
// const debounced = useDebounce(searchFn, 300, options);
// For available options see https://lodash.com/docs#debounce
export function useDebounce(fn, delay = 300, options = defaultOptions) {
  const fnRef = useRef(fn);

  useEffect(() => {
    fnRef.current = fn;
  }, [fn]);

  const debounced = useMemo(
    () => debounce((...args) => fnRef.current(...args), delay, options),
    [delay, options]
  );

  useEffect(() => {
    return () => debounced.cancel();
  }, [debounced]);

  return debounced;
}
